import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start" }, "Filtrar Políticas", -1)
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-row gap-2" }

import { ref, watchEffect, computed } from 'vue'

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'

export interface QualificationTransferFilters {
  companies: string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterModal',
  props: {
    modalActive: { type: Boolean },
    appliedFilters: {}
  },
  emits: ["close", "apply-filters"],
  setup(__props: any, { emit }) {

const props = __props;





const { listCompanies } = storeToRefs(useCompanyStore())

const selectedCompanies = ref<string[]>([])

const hasFilters = computed(() => selectedCompanies.value.length > 0)

function applyFilters() {
  emit('apply-filters', { companies: selectedCompanies.value })
  emit('close')
}

function clearFilters() {
  selectedCompanies.value = []
  emit('apply-filters', { companies: [] })
  emit('close')
}

function close() {
  emit('close')
}

watchEffect(() => {
  if (props.modalActive && props.appliedFilters) {
    selectedCompanies.value = props.appliedFilters.companies || []
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: close,
    modalActive: _ctx.modalActive,
    "max-width": "max-w-lg"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlineButton, {
          onClick: clearFilters,
          text: "Limpar filtros",
          width: "50%",
          "data-testid": "filter-clear-button"
        }),
        _createVNode(FilledButton, {
          disabled: !hasFilters.value,
          onClick: applyFilters,
          text: "Aplicar Filtros",
          width: "50%",
          class: "!bg-primary30",
          "data-testid": "filter-apply-button"
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_autocomplete, {
          modelValue: selectedCompanies.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCompanies).value = $event)),
          items: _unref(listCompanies),
          "item-title": "title",
          "item-value": "value",
          label: "Selecione as Empresas",
          multiple: "",
          chips: "",
          clearable: "",
          "deletable-chips": "",
          variant: "outlined",
          class: "w-full",
          "data-testid": "filter-company-select"
        }, null, 8, ["modelValue", "items"])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})